import { useaxios } from "../../../utils/useaxios";
export default (sell_invoice_type, sell_invoice_date, sell_invoice_note, sell_invoice_discount, sell_invoice_dollar_price, sell_invoice_loan_in_amount, sell_invoice_customer_name, sell_invoice_customer_address, sell_invoice_customer_phone, customer_id, user_id, items) => recaller => setrecaller => initDispatch => clear => printFn => setinvoiceno => setsell_loading => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + " " + today.getHours() + ":" + today.getMinutes() + ":" + today.getMinutes();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('sell_invoice/create.php', { sell_invoice_type, sell_invoice_date: today, sell_invoice_note, sell_invoice_discount, sell_invoice_dollar_price, sell_invoice_loan_in_amount, sell_invoice_customer_name, sell_invoice_customer_address, sell_invoice_customer_phone, customer_id, user_id, items }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            setsell_loading(false);
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            setinvoiceno(res.invoiceno);
            setTimeout(() => {
                printFn();
                setrecaller(recaller + 1);
                setsell_loading(false);
            }, 800);
        }
        // setloading(false);
    });
}